import { RootState } from '@/core/store/store'
import { createSelector } from '@reduxjs/toolkit'

const sidebar = (state: RootState) => state.appReducer
export const sidebarSelector = createSelector(
  sidebar,
  appReducer => appReducer.sidebar,
)

const empty = (state: RootState) => state.appReducer
export const emptySelector = createSelector(
  empty,
  appReducer => appReducer.empty,
)

const security = (state: RootState) => state.appReducer
export const securitySelector = createSelector(
  security,
  appReducer => appReducer.security,
)

const exchange = (state: RootState) => state.appReducer
export const exchangeSelector = createSelector(
  exchange,
  appReducer => appReducer.exchange,
)

const currencyDay = (state: RootState) => state.appReducer
export const currencyDaySelector = createSelector(
  currencyDay,
  appReducer => appReducer.currencyDay,
)

const changeEmailStatus = (state: RootState) => state.appReducer
export const changeEmailStatusSelector = createSelector(
  changeEmailStatus,
  appReducer => appReducer.changeEmailStatus,
)
